import actions from "@/store/modules/organisations/organisation-booking-templates/actions";
import {
  mutations,
  state
} from "@/store/modules/organisations/organisation-booking-templates/mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
